module.exports = __webpack_public_path__ + "static/images/bookmark-fill.3BU6xbP.svg";